import * as actionTypes from "./actionTypes";

export const getPaysafeDetails = (applicationId, callback = () => {}) => ({
  type: actionTypes.GET_PAYSAFE_DETAILS,
  applicationId,
  callback,
});
